import './header-user.less'
import appsotre from '@/assets/yinfgyogn.png'
import {getOtherSystemLink} from '@/api/user.js'

export default {
  name:'app-store',
  data(){
    return {
      show:false
    }
  },
  async mounted(){
    const code = await getOtherSystemLink()
    try {
      const showAppStore = new Function(code.data)
      showAppStore()
    } catch (error) {
      console.error(error)
    }

  },
  render(){
    return (
      <div class="action-bar">
        <span>
          <img src={appsotre} class="icon"/>
          <span>应用中心</span>
        </span>
        <div class="app-store-box" data-functions-container></div>
      </div>
    )
  }
}
